export default __webpack_public_path__ + "static/media/RESTAURANT.2ecbb904.png";